import Hero from "@/components/Hero";
import FeaturedCars from "@/components/FeaturedCars";
import SearchPanel from "@/components/SearchPanel";
import { WhyChooseUs, Services } from "@/components/WhyAndServices";
import Stats from "@/components/Stats";
import ReviewsElfsight from "@/components/ReviewsElfsight";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import { FinanceSection, TradeInSection } from "@/components/FinanceAndTradeIn";
import useDocumentMeta from "@/lib/useDocumentMeta";

export default function HomePage() {
    useDocumentMeta({
        title: "Konstantin Mobile — Премиум автомобили в Петрич | konstantin-mobile.bg",
        description:
            "Внимателно подбрани премиум автомобили с проверена история. Над 700 продадени автомобила. Сертифицирана автокъща в Петрич с прозрачна сервизна документация.",
        path: "/",
    });
    return (
        <main data-testid="home-page">
            <Hero />
            {/* Logo watermark — visible behind all sections after the Mercedes hero */}
            <div className="relative">
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-0 z-0"
                >
                    <div
                        className="sticky top-0 h-screen w-full opacity-[0.10]"
                        style={{
                            backgroundImage: "url(/ks-logo.png)",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center 30%",
                            backgroundSize: "min(55vw, 850px) auto",
                        }}
                    />
                </div>
                <div className="relative z-10">
                    <FeaturedCars />
                    <SearchPanel />
                    <WhyChooseUs />
                    <Stats />
                    <Services />
                    <FinanceSection />
                    <TradeInSection />
                    <About />
                    <ReviewsElfsight />
                    <Gallery />
                    <Contact />
                </div>
            </div>
        </main>
    );
}
